import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FaPhone, FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About Us' },
    { to: '/services', label: 'Services' },
    { to: '/doctors', label: 'Dental Specialists' },
    { to: '/blog', label: 'Oral Health Blog' },
    { to: '/testimonials', label: 'Patient Reviews' },
    { to: '/contact', label: 'Contact' },
  ];

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : 'transparent'}`}>
        <div className="navbar-inner">
          <Link to="/" className="navbar-logo" id="navbar-logo" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <div style={{
              background: 'linear-gradient(135deg, #e12454 0%, #8fb569 100%)',
              color: 'white',
              width: '42px',
              height: '42px',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.4rem',
              fontWeight: 'bold',
              boxShadow: '0 4px 12px rgba(225, 36, 84, 0.3)'
            }}>
              🦷
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: '1.25rem', fontWeight: 800, color: 'var(--color-navy, #0f2040)', lineHeight: 1.1, letterSpacing: '-0.02em' }}>
                UK Dental <span style={{ color: '#e12454' }}>Studio</span>
              </span>
              <span style={{ fontSize: '0.7rem', color: '#656565', fontWeight: 600, letterSpacing: '0.05em', textTransform: 'uppercase' }}>
                Dr. Tanya Chauhan & Team
              </span>
            </div>
          </Link>

          <div className="navbar-nav">
            {navLinks.map(link => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === '/'}
                className={({ isActive }) => isActive ? 'active' : ''}
              >
                {link.label}
              </NavLink>
            ))}
          </div>

          <div className="navbar-actions">
            <a href="tel:+919536113530" className="navbar-phone" id="navbar-phone">
              <FaPhone style={{ fontSize: '0.8rem' }} />
              +91 95361 13530
            </a>
            <Link to="/appointments" className="btn btn-primary" id="navbar-cta" style={{ padding: '0.65rem 1.4rem', fontSize: '0.875rem' }}>
              Book Appointment
            </Link>
            <button
              className="navbar-toggle"
              id="navbar-toggle"
              onClick={() => setMenuOpen(true)}
              aria-label="Open menu"
            >
              <FaBars />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`} id="mobile-menu">
        <button className="mobile-menu-close" onClick={() => setMenuOpen(false)} id="mobile-menu-close">
          <FaTimes />
        </button>
        <div className="navbar-logo" style={{ marginBottom: '2rem', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <div style={{
            background: 'linear-gradient(135deg, #e12454 0%, #8fb569 100%)',
            color: 'white',
            width: '38px',
            height: '38px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.2rem',
            fontWeight: 'bold'
          }}>
            🦷
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: '1.15rem', fontWeight: 800, color: 'var(--color-navy, #0f2040)', lineHeight: 1.1 }}>
              UK Dental <span style={{ color: '#e12454' }}>Studio</span>
            </span>
            <span style={{ fontSize: '0.65rem', color: '#656565', fontWeight: 600 }}>
              Dr. Tanya Chauhan & Team
            </span>
          </div>
        </div>
        <nav className="mobile-menu-nav">
          {navLinks.map(link => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) => isActive ? 'active' : ''}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
        <div style={{ marginTop: '2rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <a href="tel:+919536113530" className="btn btn-secondary" style={{ justifyContent: 'center' }}>
            <FaPhone /> +91 95361 13530
          </a>
          <Link to="/appointments" className="btn btn-primary" style={{ justifyContent: 'center' }} onClick={() => setMenuOpen(false)}>
            Book Appointment
          </Link>
        </div>
      </div>
    </>
  );
};

export default Navbar;
